export default __webpack_public_path__ + "04f966228c3fb8f659b11cc54bde0c2f.twig";